<template>
  <div class="link">
    <div class="inner_content">
      <div class="link_left">
        <div class="link_type">
          <div class="title">友情链接</div>
          <ul class="link_list">
            <li><a href="https://www.mitsubishielectric.com.cn/zh/index.html" target="_blank">三菱电机（中国）官方</a></li>
            <li><a href="https://www.mebs.com/index.html" target="_blank">三菱电机楼宇解决方案株式会社</a></li>
            <li><a href="https://www.smec-cn.com/" target="_blank">上海三菱电梯有限公司</a></li>
          </ul>
        </div>
        <div class="link_type">
          <div class="title">更多</div>
          <ul class="link_list">
            <li><a href="https://www.smec-cn.com/contact/#contact" target="_blank">营销服务网络</a></li>
            <li><a href="/contact/catalog">产品手册</a></li>
          </ul>
        </div>
      </div>
      <div class="link_right">
        <div class="tel"><span>全国服务热线：</span> <span>400-820-3030</span></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
}
</script>
<style scoped lang="less">
.link {
  font-weight: 300;
  line-height: 1.4;
  font-size: 18px;
  background-image: url(../assets/img/footer.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;

  .inner_content {
    // background-color: #fff;
    height: 230px;
    padding: 20px 0;
    max-width: 1440px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    .link_left {
      width: 60%;
      display: flex;

      .link_type {
        flex: 1;

        .title {
          font-size: 24px;
          margin-bottom: 20px;
          position: relative;
          padding-left: 26px;
          text-align: left;
          font-weight: 700;

          &::before {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 6px;
            content: '';
            width: 3px;
            height: 30px;
            background-color: #e00024;
          }
        }

        .link_list {
          display: inline-block;
          list-style: none;
          padding: 1px 0 0 22px;

          li {
            margin-bottom: 18px;

            a {
              position: relative;
              font-size: 18px;
              font-weight: 500;
              text-decoration: none;
              padding-left: 22px;
              color: #000;

              &:visited {
                color: #000;
              }

              &:hover {
                text-decoration: underline;
              }

              &::before {
                content: "";
                position: absolute;
                top: 50%;
                left: 0;
                width: 9px;
                height: 9px;
                border-top: 2px solid #e00024;
                border-left: 2px solid #e00024;
                transform: translateY(-50%) rotate(-225deg);
                font-weight: 700;
              }
            }
          }
        }
      }
    }

    .link_right {
      display: flex;
      align-items: flex-end;

      .tel {

        span {
          font-size: 26px;
          font-weight: 700;
        }
      }
    }
  }
}

@media (max-width: 991px) {
  .link {
    background-image: url(../assets/img/footer_yd.png);

    .inner_content {
      height: auto;
      padding: 20px 10px;
      flex-direction: column;

      .link_left {
        width: 100%;
        flex-direction: column;

        .link_type {
          flex: 1;

          .link_list {
            display: inline-block;
            list-style: none;
            padding: 1px 0 0 22px;

            li {
              margin-bottom: 18px;

              a {
                font-size: 16px;
              }
            }
          }
        }
      }

      .link_right {

        .tel {

          span {
            font-size: 22px;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/link.vue